import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import * as FaIcons from "react-icons/fa";
import "../HRManagement/leavePolicies.css";
import "./leavePortal.css";
import LeaveRequestsPanel from "./LeaveRequestsPanel";

function LeaveRequestStatus() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");

  useEffect(() => {
    const user_id = JSON.parse(localStorage.getItem("user_id"));
    if (user_id) setUserId(user_id);
  }, []);

  return (
    <>
      <header className="border-bottom lp-portal-header">
        <div className="container px-4 py-4">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => navigate("/leave")}
            >
              <FaIcons.FaArrowLeft className="me-1" />
              Back
            </button>
            <div>
              <h1 className="h3 fw-bold mb-1">Leave Request Status</h1>
              <p className="text-muted small mb-0">
                Track all your submitted leave applications
              </p>
            </div>
          </div>
        </div>
      </header>

      <div className="container py-4">
        <LeaveRequestsPanel userId={userId} />
      </div>
    </>
  );
}

export default LeaveRequestStatus;
